module.exports = __webpack_public_path__ + "static/media/1017089.c98f51bd.png";